import * as React from "react";
const CalenderIcon = ({ className, fill }) => {
  const [_class, setClass] = React.useState(className);

  React.useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={_class}
    >
      <g clipPath="url(#clip0_173204_8478)">
        <path
          d="M14 1.33333H12V0H10.6667V1.33333H5.33333V0H4V1.33333H2C1.46957 1.33333 0.960859 1.54405 0.585786 1.91912C0.210714 2.29419 0 2.8029 0 3.33333L0 16H16V3.33333C16 2.8029 15.7893 2.29419 15.4142 1.91912C15.0391 1.54405 14.5304 1.33333 14 1.33333ZM1.33333 3.33333C1.33333 3.15652 1.40357 2.98695 1.5286 2.86193C1.65362 2.7369 1.82319 2.66667 2 2.66667H14C14.1768 2.66667 14.3464 2.7369 14.4714 2.86193C14.5964 2.98695 14.6667 3.15652 14.6667 3.33333V5.33333H1.33333V3.33333ZM1.33333 14.6667V6.66667H14.6667V14.6667H1.33333Z"
          fill={fill}
        />
        <path d="M11.3333 8.66666H10V9.99999H11.3333V8.66666Z" fill={fill} />
        <path
          d="M8.66732 8.66666H7.33398V9.99999H8.66732V8.66666Z"
          fill={fill}
        />
        <path
          d="M5.99935 8.66666H4.66602V9.99999H5.99935V8.66666Z"
          fill={fill}
        />
        <path d="M11.3333 11.3333H10V12.6667H11.3333V11.3333Z" fill={fill} />
        <path
          d="M8.66732 11.3333H7.33398V12.6667H8.66732V11.3333Z"
          fill={fill}
        />
        <path
          d="M5.99935 11.3333H4.66602V12.6667H5.99935V11.3333Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_173204_8478">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CalenderIcon;
